import TheGrid from '@/views/stars/ws_objectives_quarter/grid'
import Edit from '@/views/stars/ws_objectives_quarter/edit'
import Importer from '@/views/stars/ws_objectives_quarter/import'

export default {
  path: '/stars/ws_objectives_quarter',
  redirect: '/stars/ws_objectives_quarter/index',
  name: 'ws_objectives_quarter',
  meta: {
    auth: {
      redirect: {
        name: 'ws_objectives_quarter.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Objectivos WS Trimestre'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'ws_objectives_quarter.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'ws_objectives_quarter.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'ws_objectives_quarter.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'ws_objectives_quarter.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
